










































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class extends Vue {
    @Prop(String) Month: string | undefined;
    @Prop({default: ''}) classPrefix: string | undefined;
    @Prop() show: boolean | undefined;
    @Prop() IncomeTotal: number | undefined;
    @Prop() ExpenseTotal: number | undefined;
    @Prop({default:'全部类型'}) SelectedTypeName: string | undefined;

    handleData() {
        this.$emit('handleDate');
    }

    handleTypes() {
        this.$emit('handleTypes');
    }

    get dateCurrent() {
        if (this.Month) {
            return this.Month;
        } else return '2020年06月';
    }


}
